/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
// Called by adding `data: { submit_on_change: true }`to a form element.
window.App.Components.Toggle = class Toggle {
  constructor() {
    $(document).on("change", "[data-submit-on-change]", function (e) {
      e.preventDefault()
      const $el = $(this)
      return $el.trigger("submit.rails")
    })
  }
}

$(document).on("turbo:load", () => new App.Components.Toggle())
